import { useEffect, useState } from "react";
import SkeletonTable from "../../../components/table/SkeletonTable";
import ModalComponent from "../../../components/modals/ModalComponent";

const ViewDocModal = ({ isDocOpen, setIsDocOpen, selectedFileForAckDocs }) => {
  const [documents, setDocuments] = useState([]);

  const defaultRender = (value) => (value ? value : "--");
  const columns = [
    {
      title: "Document Name",
      dataIndex: "original_name",
      render: defaultRender,
      width: 100,
    },
    {
      title: "Action",
      dataIndex: "view_file",
      render: defaultRender,
    },
  ];

  useEffect(() => {
    setDocuments(
      selectedFileForAckDocs?.acknowledge?.map((data) => {
        return {
          original_name: (
            <div
              className="sub-title highlight-text truncate max-w-[250px]"
              title={data?.original_name}
            >
              {data?.original_name || "--"}
            </div>
          ),
          view_file: (
            <a href={data?.full_path} target="_blank" className="text-blue-500">
              View File
            </a>
          ),
        };
      })
    );
  }, [selectedFileForAckDocs]);

  return (
    <ModalComponent
      title="All Acknowledgement Documents"
      isOpen={isDocOpen}
      setIsOpen={setIsDocOpen}
    >
      <SkeletonTable columns={columns} data={documents} />
    </ModalComponent>
  );
};

export default ViewDocModal;
